@if (period) {
    <div
        id="colaborator-card"
        fxLayout="column"
        fxLayoutAlign="center center"
        [ngStyle]="{ 'height.px': projectName === 'syrsa' ? 'auto' : 'auto' }"
    >
        <!-- Tranfer, Fedback -->
        @if (!checkCurrent) {
            <div class="transfer">
                @if (evaluation.type === "TRANSFER") {
                    <mat-icon class="green" [title]="'Cedido por ' + originalEvaluator">arrow_forward</mat-icon>
                }
                @if (transferedTo) {
                    <mat-icon
                        class="pointer red"
                        [title]="'Cedido a ' + transferedTo.newEvaluatorName"
                        (click)="openTransferDialog()"
                        >arrow_back</mat-icon
                    >
                }
                @for (pf of privateFeedbackList(); track pf) {
                    <mat-icon
                        class="pointer"
                        [title]="'Feedback privado solicitado a ' + pf.personResponseName"
                        (click)="openFeedbackDialog(pf)"
                        >feedback</mat-icon
                    >
                }
            </div>
        }
        @if (
            period.isActive &&
            (period.isEnabledEvaluationTransfer || period.isEnabledPrivateFeedback) &&
            evaluation.personId != userId
        ) {
            <div class="transfer-menu">
                <button
                    mat-icon-button
                    [matMenuTriggerFor]="colaboratorMenu"
                    class="quick-panel-toggle-button menu-button"
                >
                    <mat-icon>menu</mat-icon>
                </button>
            </div>
        }
        <mat-menu #colaboratorMenu="matMenu" [overlapTrigger]="false">
            @if (period.isEnabledEvaluationTransfer) {
                <button mat-menu-item (click)="openTransferDialog()">
                    <mat-icon class="m-0">arrow_back</mat-icon>
                    Cesión de evaluación
                </button>
            }
            @if (period.isEnabledPrivateFeedback) {
                <button mat-menu-item (click)="openFeedbackDialog()">
                    <mat-icon class="m-0">feedback</mat-icon>
                    Solicitar feedback privado
                </button>
            }
            @if (projectName.includes("iberext")) {
                <button mat-menu-item (click)="addNota()">
                    <mat-icon class="m-0">assignment</mat-icon>
                    Ver notas
                </button>
            }
        </mat-menu>
        <div class="person-avatar" fxLayout="row" fxLayoutAlign="center flex-start">
            <img class="img-circle" [src]="getImagePerson(evaluation.nickname)" [alt]="evaluation.firstName" />
        </div>
        <h5 class="name-user">
            <strong>{{ evaluation.displayName }}</strong>
        </h5>
        <h5 class="puesto-user">{{ evaluation.puesto?.puesto }}</h5>
        <p>
            <a class="pointer" (click)="goToDashboard(evaluation.personId)">{{
                "evaluation.filter.btn.dashboard" | translate
            }}</a>
        </p>
        <!-- Planes de accion -->
        <p>{{ "evaluation.controlpanel.actionsplans" | translate }} {{ evaluation.actionPlans }}</p>
        @if (period.isAtivedPeriodRevision && userId != evaluation.personId) {
            <div fxLayout="column" fxLayoutAlign="center center">
                @if (actionPlansPendingsRevision === 0) {
                    <button class="action-button btn-success pointer" (click)="goToDashboard(evaluation.personId)">
                        Revisados
                    </button>
                }
                @if (actionPlansPendingsRevision > 0) {
                    <button class="action-button btn-danger pointer" (click)="goToDashboard(evaluation.personId)">
                        {{ actionPlansPendingsRevision }}
                        {{ "evaluation.controlpanel.actionsplans.pendings" | translate }}
                    </button>
                }
            </div>
        }
        @if (projectName === "syrsa") {
            @if (isBorradorCompletado && isDraftByEvaluator) {
                <p style="color: green">Borrador guardado como completado</p>
            }
        }
        @if (period.isEnabledPrivateFeedback) {
            <p>Feedback Privado Disponible: {{ privateFeedbackCount }}</p>
        }
        <!-- Autoevalucion -->
        @if (evaluation.hasAutoevaluation) {
            <div>
                @if (evaluation.isAutoevaluationPending) {
                    <div class="eval-pending" fxLayoutAlign="center center">
                        <span>{{ "evaluation.filter.card.autopending" | translate }}</span>
                        <mat-icon
                            class="pointer"
                            (click)="sendUserPendingEvaluationMail(evaluation.personId)"
                            title="Avisar de autoevaluación"
                            >notifications</mat-icon
                        >
                    </div>
                }
                @if (!evaluation.isAutoevaluationPending) {
                    <div class="eval-done" fxLayoutAlign="center center">
                        <span>{{ "evaluation.filter.card.autocompleted" | translate }}</span>
                    </div>
                }
            </div>
        }
        @if (!lessThan6months && projectName !== "syrsa") {
            <button
                class="action-button pointer"
                [disabled]="!checkCurrent && transferedTo"
                [ngClass]="!checkCurrent && transferedTo ? 'disabled' : ''"
                (click)="goToEvaluationForm()"
            >
                {{ getEvaluationStatusButton() }}
            </button>
        }
        @if (!lessThan6months && projectName === "syrsa") {
            <button
                class="action-button pointer"
                [disabled]="(!checkCurrent && transferedTo) || !aspectosOk"
                [ngClass]="(!checkCurrent && transferedTo) || !aspectosOk ? 'disabled' : ''"
                (click)="goToEvaluationForm()"
            >
                {{ getEvaluationStatusButton() }}
            </button>
        }
        @if (lessThan6months) {
            <h3><b>No aplica</b></h3>
        }
        @if (showNotDone) {
            <div fxLayout="row" fxLayoutAlign="center" class="mt-8 resumen">
                <div fxLayoutAlign="center" fxFlex="50" title="Nota total">
                    <fa-icon class="mr-4" icon="file-alt"></fa-icon>
                    <span style="font-size: 14px">No evaluado</span>
                </div>
            </div>
        } @else {
            <div fxLayout="row" fxLayoutAlign="center" class="mt-8 resumen">
                @if (period.es_cualitativa == 0) {
                    <div fxLayoutAlign="center" fxFlex="50" title="Nota total">
                        <fa-icon class="mr-4" icon="file-alt"></fa-icon>
                        @if (checkCurrent) {
                            @if (evaluation.result) {
                                <span>{{ roundTwoDecimals(evaluation.result) }} / 100</span>
                            } @else {
                                <span>- / 100</span>
                            }
                        } @else {
                            @if (isDoneByEvaluator) {
                                <span>{{ roundTwoDecimals(evaluation.result) }} / 100</span>
                            }
                            @if (!isDoneByEvaluator && isDraftByEvaluator) {
                                <span> {{ roundTwoDecimals(partial?.result) }} / 100</span>
                            }
                            @if (!isDoneByEvaluator && !isDraftByEvaluator) {
                                <span> - / 100</span>
                            }
                        }
                    </div>
                }
                @if (period.es_cualitativa == 1) {
                    <div fxLayoutAlign="center" fxFlex="70" title="Nota total" class="font-size-14">
                        <span>Evaluación cualitativa</span>
                    </div>
                }
                @if (period.isEvaluatedCompetenciesBadges) {
                    <div fxLayoutAlign="center" fxFlex="50" title="Nota medallas">
                        <fa-icon class="mr-4" icon="medal"></fa-icon>
                        <span>- / 100</span>
                    </div>
                }
            </div>
        }
        <!-- Aspects -->
        @if (period.isEnabledEvaluationAspect) {
            <div
                fxLayout="row wrap"
                fxLayoutAlign="space-between center"
                class="aspects mt-8"
                style="margin-bottom: 5px"
            >
                @for (aspect of aspectsList; track aspect) {
                    @if (projectName !== "syrsa") {
                        <div fxLayout="column" fxLayoutAlign="center center" [ngClass]="aspect.class">
                            <div fxLayout="row">
                                <mat-label>{{ aspect.name }}</mat-label>
                                @if (aspect.helpText) {
                                    <mat-icon [title]="aspect.helpText" class="help">help</mat-icon>
                                }
                            </div>
                            <!-- Select -->
                            @if (aspect.type === "SELECT") {
                                <mat-form-field subscriptSizing="dynamic" dense appearance="outline" class="select">
                                    <input matInput style="display: none" />
                                    <mat-select
                                        [id]="evaluation.personId + '-' + aspect.id"
                                        class="form-control"
                                        [value]="getAspectValue(evaluation.aspects, aspect.id)"
                                        [disabled]="!period.isActive || (lessThan6months && projectName === 'syrsa')"
                                    >
                                        <mat-option
                                            value=""
                                            (click)="onSelectAspect(aspect.id, '', evaluation.personId)"
                                            >-</mat-option
                                        >
                                        @for (value of aspect.values; track value) {
                                            <mat-option
                                                [value]="value.id"
                                                (click)="onSelectAspect(aspect.id, value.id)"
                                                >{{ value.name }}</mat-option
                                            >
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }
                            <!-- Potencial -->
                            @if (aspect.type === "EVALUATION_POTENCIAL") {
                                <div class="potencial">
                                    <div>{{ evaluation.potencial }} / 100</div>
                                </div>
                            }
                            <!-- Person -->
                            @if (aspect.type === "PERSON") {
                                <div class="person">
                                    <div class="fullwidth" style="position: relative; margin-top: 5px">
                                        <mat-form-field
                                            subscriptSizing="dynamic"
                                            [id]="evaluation.personId + '-' + aspect.id"
                                            class="search-user w-95-p"
                                        >
                                            <input
                                                matInput
                                                placeholder="Buscar persona"
                                                [(ngModel)]="filterPersonValue"
                                                (keyup)="filterPersons($event)"
                                                [disabled]="
                                                    !period.isActive || (lessThan6months && projectName === 'syrsa')
                                                "
                                            />
                                            @if (!personSelected && filterPersonValue.length === 0) {
                                                <mat-icon matIconSuffix class="s-18">search</mat-icon>
                                            }
                                            @if (filterPersonValue.length > 0 && period.isActive) {
                                                <button
                                                    matIconSuffix
                                                    mat-icon-button
                                                    aria-label="Clear"
                                                    (click)="clearPerson(aspect.id)"
                                                >
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            }
                                        </mat-form-field>
                                        @if (persons().length > 0 && !personSelected) {
                                            <div class="wrap-persons">
                                                <div class="list-persons">
                                                    @for (person of persons(); track person) {
                                                        <div
                                                            fxlayout="row"
                                                            fxLayoutAlign="flex-start center"
                                                            class="item-person"
                                                            (click)="selectPerson(aspect.id, person)"
                                                        >
                                                            <div
                                                                class="person-avatar avatar-50 mr-8"
                                                                fxLayout="row"
                                                                fxLayoutAlign="center center"
                                                            >
                                                                <img
                                                                    class="img-circle"
                                                                    [src]="getImagePerson(person.username)"
                                                                    [title]="person.username"
                                                                />
                                                            </div>
                                                            <div fxLayout="column" class="info-person">
                                                                <span class="m-0">{{ "@" + person.username }}</span>
                                                                <span class="m-0"
                                                                    ><strong>{{ person.displayName }}</strong></span
                                                                >
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    @if (projectName === "syrsa") {
                        <div fxLayout="column" fxLayoutAlign="center center" [ngClass]="aspect.class">
                            @if (aspect.id == 13 || aspect.id == 10) {
                                <div
                                    fxLayout="column"
                                    style="border-bottom: 1px solid rgb(61, 61, 61); width: 100%; height: 15px"
                                ></div>
                            }
                            @if (aspect.id == 13 || aspect.id == 10) {
                                <div fxLayout="column" style="width: 100%; height: 14px"></div>
                            }
                            @if (
                                projectName === "syrsa" &&
                                (aspect.id == 13 ||
                                    aspect.id == 10 ||
                                    (aspect.id == 11 && arrayAspectos[1] == 1) ||
                                    (aspect.id == 12 && arrayAspectos[2] == 1))
                            ) {
                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                    [ngClass]="aspect.class"
                                    [ngStyle]="{ 'background-color': colorMap[aspect.id] || 'transparent' }"
                                >
                                    @if (aspect.id == 10) {
                                        <div fxLayout="row" style="padding-top: 5px">
                                            <mat-label>PLAN DE SUCESIÓN</mat-label>
                                        </div>
                                    }
                                    @if (aspect.id == 10) {
                                        <div fxLayout="row" style="padding-top: 5px">
                                            <mat-label>Desde tu punto de vista...</mat-label>
                                        </div>
                                    }
                                    <div fxLayout="row">
                                        <mat-label [ngStyle]="{ 'padding-top': aspect.id != 10 ? '5px' : '0px' }">{{
                                            aspect.name
                                        }}</mat-label>
                                        @if (aspect.helpText) {
                                            <mat-icon [title]="aspect.helpText" class="help">help</mat-icon>
                                        }
                                    </div>
                                    <!-- Select -->
                                    @if (aspect.type === "SELECT") {
                                        <div style="width: 90%; margin-bottom: 5px">
                                            <input matInput style="display: none" />
                                            <mat-select
                                                [id]="evaluation.personId + '-' + aspect.id"
                                                class="form-control"
                                                [value]="getAspectValue(evaluation.aspects, aspect.id)"
                                                [disabled]="
                                                    !period.isActive || (lessThan6months && projectName === 'syrsa')
                                                "
                                            >
                                                <mat-option
                                                    value=""
                                                    (click)="onSelectAspect(aspect.id, '', evaluation.personId)"
                                                    >-</mat-option
                                                >
                                                @for (value of aspect.values; track value) {
                                                    <mat-option
                                                        [value]="value.id"
                                                        (click)="onSelectAspect(aspect.id, value.id)"
                                                        >{{ value.name }}</mat-option
                                                    >
                                                }
                                            </mat-select>
                                        </div>
                                    }
                                    <!-- Potencial -->
                                    @if (aspect.type === "EVALUATION_POTENCIAL") {
                                        <div class="potencial">
                                            <div>{{ evaluation.potencial }} / 100</div>
                                        </div>
                                    }
                                    <!-- Person -->
                                    @if (aspect.type === "PERSON") {
                                        <div class="person">
                                            <div class="fullwidth" style="position: relative; margin-top: 5px">
                                                <mat-form-field
                                                    subscriptSizing="dynamic"
                                                    [id]="evaluation.personId + '-' + aspect.id"
                                                    class="search-user w-100-p"
                                                    style="max-height: 40px !important; margin-bottom: 3px"
                                                >
                                                    <input
                                                        matInput
                                                        placeholder="Buscar persona"
                                                        [(ngModel)]="filterPersonValue"
                                                        (keyup)="filterPersons($event)"
                                                        [disabled]="
                                                            !period.isActive ||
                                                            (lessThan6months && projectName === 'syrsa')
                                                        "
                                                    />
                                                    @if (!personSelected && filterPersonValue.length === 0) {
                                                        <mat-icon matIconSuffix class="s-18">search</mat-icon>
                                                    }
                                                    @if (personSelected && period.isActive) {
                                                        <mat-icon
                                                            matIconSuffix
                                                            (click)="clearPerson(aspect.id)"
                                                            class="s-18"
                                                            >close</mat-icon
                                                        >
                                                    }
                                                </mat-form-field>
                                                @if (persons().length > 0 && !personSelected) {
                                                    <div class="wrap-persons">
                                                        <div class="list-persons">
                                                            @for (person of persons(); track person) {
                                                                <div
                                                                    fxlayout="row"
                                                                    fxLayoutAlign="flex-start center"
                                                                    class="item-person"
                                                                    (click)="selectPerson(aspect.id, person)"
                                                                >
                                                                    <div
                                                                        class="person-avatar avatar-50 mr-8"
                                                                        fxLayout="row"
                                                                        fxLayoutAlign="center center"
                                                                    >
                                                                        <img
                                                                            class="img-circle"
                                                                            [src]="getImagePerson(person.username)"
                                                                            [title]="person.username"
                                                                        />
                                                                    </div>
                                                                    <div fxLayout="column" class="info-person">
                                                                        <span class="m-0">{{
                                                                            "@" + person.username
                                                                        }}</span>
                                                                        <span class="m-0"
                                                                            ><strong>{{
                                                                                person.displayName
                                                                            }}</strong></span
                                                                        >
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                }
            </div>
        }
    </div>
}
